import React from 'react';

export interface HeaderTitanContractProps {
  contractNumber?: string;
  logoSrc?: string;
}

// Helper component for blank underline
const BlankField: React.FC<{ width?: string }> = ({ width = 'w-32' }) => (
  <span className={`inline-block border-b border-gray-900 ${width} h-px ml-1 translate-y-[-2px]`}></span>
);

const HeaderTitanContract: React.FC<HeaderTitanContractProps> = ({
  contractNumber,
  logoSrc = '/images/logo/logoweb.webp',
}) => {
  return (
    <>
      {/* Header Block */}
      <div className="pdf-block !relative !mb-10 !pt-4" style={{ minHeight: '120px' }}>
        <div className="!absolute !top-0 !left-0 !w-20 pdf-logo">
          <img
            src={logoSrc}
            alt="BeQ Holdings Logo"
            className="!w-16 !h-16 !object-contain"
          />
        </div>

        <div className="text-center">
          <p className="!text-[12px] !font-bold !uppercase !m-0" style={{ color: '#000' }}>
            CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
          </p>
          <p className="!text-[11px] !m-0" style={{ color: '#000' }}>
            Độc lập – Tự do – Hạnh phúc
          </p>
          <div className="!w-24 !h-[1px] !bg-black !mx-auto !mt-1 !mb-4"></div>

          <h1 className="!text-lg !font-bold !uppercase !mt-6" style={{ color: '#000' }}>
            HỢP ĐỒNG HỢP TÁC ĐẦU TƯ
          </h1>
          <p className="!text-sm">
            Số: {contractNumber || <BlankField width="w-32" />}{contractNumber ? '' : <BlankField width="w-16" />}
          </p>
        </div>
      </div>

      {/* Legal Basis Section */}
      <div className="text-center !mb-8 !mt-8 pdf-block">
        <div className="!text-xs !text-gray-900 dark:!text-gray-400 !text-left !space-y-1 !mb-6">
          <p>- Căn cứ Bộ luật Dân sự số 91/2015/QH13 ngày 24/11/2015;</p>
          <p>- Căn cứ Luật Đầu tư số 61/2020/QH14 ngày 17/6/2020;</p>
          <p>- Căn cứ Luật Doanh nghiệp số 59/2020/QH14 ngày 17/6/2020;</p>
          <p>- Luật Thương mại số 36/2005/QH11 ngày 14/06/2005 và các văn bản hướng dẫn liên quan;</p>
          <p>- Căn cứ nhu cầu và khả năng của các Bên;</p>
          <p>- Căn cứ thỏa thuận của các Bên về hợp tác đầu tư dự án nền tảng công nghệ LUMIR và CCPI cũng như cơ chế chia sẻ doanh thu ròng.</p>
        </div>
      </div>
    </>
  );
};

export default HeaderTitanContract;
